import { render, staticRenderFns } from "./Guardians.vue?vue&type=template&id=34f8d0c0&scoped=true&"
import script from "./Guardians.vue?vue&type=script&lang=js&"
export * from "./Guardians.vue?vue&type=script&lang=js&"
import style0 from "./Guardians.vue?vue&type=style&index=0&id=34f8d0c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f8d0c0",
  null
  
)

export default component.exports